import {getSelectedDeliveryCountry} from '../selectors/selectors';
import store from '../store/store';
import DomUtils from './DomUtils';
import Track from './tracking';

const maxAttempts = 10;

function loadAfterPayAndRedirect(token, countryCode, count = 0) {
  if (typeof window.AfterPay !== 'undefined') {
    window.AfterPay.initialize({countryCode});
    window.AfterPay.redirect({token});
  } else if (count <= maxAttempts) {
    setTimeout(() => {
      loadAfterPayAndRedirect(token, countryCode, count + 1);
    }, 1000);
  }
}

export default function redirectToAfterPay(paymentMethod, token) {
  const state = store.getState();
  const {start} = state;
  const countryCode = getSelectedDeliveryCountry(state).toUpperCase();
  let scriptUrl;
  if (paymentMethod === 'CLEARPAY') {
    scriptUrl = 'https://portal.clearpay.co.uk/afterpay.js'
    
    if (start.settings.use_clearpay_sandbox_script === true) {
      scriptUrl = 'https://portal.sandbox.clearpay.com/afterpay.js'
    } else if (start.settings.use_clearpay_sandbox_script) {
      scriptUrl = start.settings.use_clearpay_sandbox_script
    }
  } else if (paymentMethod === 'AFTERPAY') {
    scriptUrl = start.settings.enabled_currencies_for_afterpay_sandbox
    && start.settings.enabled_currencies_for_afterpay_sandbox
      .includes(start.orderTotal && start.orderTotal.currencyCode)
      ? 'https://portal.sandbox.afterpay.com/afterpay.js'
      : 'https://portal.afterpay.com/afterpay.js';
  } else {
    Track.error('unexpected paymentMethod in orderStatus response');
    return Promise.reject();
  }
  return DomUtils.addScript(scriptUrl)
    .then(() => {
      loadAfterPayAndRedirect(token, countryCode);
    });
}
